._1m2x3e31 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--roctvq26);
  width: 100%;
  transition: 0.3s padding;
}
._1m2x3e32 {
  background-color: var(--roctvq2);
  box-shadow: 0 4px 4px rgba(var(--roctvq1), 0.04);
}
._1m2x3e33 {
  display: flex;
  height: 56px;
  transition: 0.3s height;
}
._1m2x3e34 {
  flex-shrink: 0;
  margin-right: 16px;
}
._1m2x3e35:not(:root) {
  display: flex;
  align-items: center;
  height: 100%;
}
._1m2x3e36 {
  width: 120px;
  height: auto;
}
._1m2x3e37 {
  display: flex;
  flex-grow: 1;
}
._1m2x3e38 {
  margin-left: auto;
}
._1m2x3e39 {
  display: flex;
  align-items: center;
  height: 100%;
}
._1m2x3e3a {
  display: flex;
  align-items: center;
  margin: -8px 0 0 -8px;
}
._1m2x3e3b {
  padding: 8px 0 0 8px;
}
._1m2x3e3c {
  margin-left: auto;
  display: flex;
}
._1m2x3e3d {
  flex-shrink: 0;
  height: 100%;
  position: relative;
  z-index: var(--roctvq2b);
}
._1m2x3e3f:not(:root) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  min-width: 64px;
  border: none;
  border-radius: 0;
  padding: 0;
  background-color: transparent;
}
._1m2x3e3g {
  display: block;
}
._1m2x3e3h {
  display: block;
  margin: 0;
  height: 16px;
  width: 24px;
  position: relative;
}
._1m2x3e3i {
  display: block;
  width: 100%;
  height: 2px;
  position: absolute;
  left: 0;
  transition: 0.3s opacity, 0.3s transform, 0.3s top, 0.3s bottom;
}
._1m2x3e3i:before {
  content: "";
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: var(--roctvqa);
  transition: 0.3s opacity;
}
._1m2x3e3i:after {
  content: "";
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(90deg, var(--roctvq12) 0, var(--roctvq14) 100%);
}
._1m2x3e3h > ._1m2x3e3i:nth-of-type(1) {
  top: 0;
}
._1m2x3e3h > ._1m2x3e3i:nth-of-type(2) {
  top: 50%;
  margin-top: -1px;
}
._1m2x3e3h > ._1m2x3e3i:nth-of-type(3) {
  bottom: 0;
}
._1m2x3e3f._1m2x3e3e ._1m2x3e3h > ._1m2x3e3i:nth-of-type(1) {
  top: 6px;
  transform: rotate(-45deg);
}
._1m2x3e3f._1m2x3e3e ._1m2x3e3h > ._1m2x3e3i:nth-of-type(2) {
  opacity: 0;
}
._1m2x3e3f._1m2x3e3e ._1m2x3e3h > ._1m2x3e3i:nth-of-type(3) {
  bottom: 8px;
  transform: rotate(45deg);
}
._1m2x3e3j {
  display: block;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  position: fixed;
  right: 0;
  top: 0;
  width: 300px;
  background-color: var(--roctvq4);
  z-index: var(--roctvq2a);
}
._1m2x3e3k {
  min-height: calc(100% + 1px);
  padding-bottom: 80px;
}
._1m2x3e3l {
  background-color: var(--roctvq8);
  padding: 56px 24px 24px;
}
._1m2x3e3m {
  display: flex;
  align-items: center;
}
._1m2x3e3n {
  flex-shrink: 0;
  margin-right: 16px;
}
._1m2x3e3o {
  display: block;
  flex-grow: 1;
  font-weight: var(--roctvq1x);
  font-size: 1rem;
  color: var(--roctvqa);
}
._1m2x3e3r {
  background-color: var(--roctvqe);
}
._1m2x3e3v:not(:root) {
  display: flex;
  padding: 16px 24px;
  text-decoration: none;
  color: var(--roctvq2);
  font-size: 0.875rem;
  font-weight: var(--roctvq1x);
}
._1m2x3e3w {
  flex-shrink: 0;
  margin-right: 16px;
}
._1m2x3e3x {
  display: inline-block;
}
._1m2x3e3y {
  margin-top: 8px;
}
._1m2x3e312:not(:root) {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  color: var(--roctvq2);
  font-size: 0.75rem;
  position: relative;
  width: 100%;
  text-align: left;
  border-radius: 0;
  border: none;
  background-color: transparent;
  transition: 0.3s color;
}
._1m2x3e312:after {
  content: "";
  position: absolute;
  width: calc(100% - 24px);
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: var(--roctvqa);
}
._1m2x3e313 {
  display: block;
}
._1m2x3e314 {
  display: none;
  position: relative;
}
._1m2x3e315:not(:root) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 180px;
  height: 100%;
  padding: 0;
  border-radius: 0;
  border: none;
  background-color: transparent;
  text-align: left;
}
._1m2x3e316 {
  flex-shrink: 0;
  margin-right: 8px;
}
._1m2x3e317 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 0.75rem;
  font-weight: var(--roctvq1x);
}
._1m2x3e318 {
  flex-shrink: 0;
  margin-left: 8px;
}
._1m2x3e319 {
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: var(--roctvq27);
}
._1m2x3e31a {
  display: block;
  width: 240px;
  border: 1px solid var(--roctvq6);
  background-color: rgba(var(--roctvq3), 0.9);
  border-radius: 0 0 4px 4px;
  padding: 16px 0;
}
._1m2x3e31f:not(:root) {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: var(--roctvqa);
  font-size: 0.75rem;
  width: 100%;
  text-align: left;
  border-radius: 0;
  border: none;
  background-color: transparent;
  transition: 0.3s color;
}
._1m2x3e31h {
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--roctvq29);
  overscroll-behavior: contain;
  overflow-y: auto;
  backdrop-filter: blur(8px);
  background-color: rgba(var(--roctvq1), 0.2);
}
._1m2x3e31i {
  min-height: calc(100% + 1px);
}
._1m2x3e31j {
  padding-top: 8px;
  position: relative;
  z-index: var(--roctvq28);
}
._1m2x3e31k {
  padding: 8px;
  background-color: var(--roctvq16);
  box-shadow: 0 4px 4px rgba(var(--roctvq1), 0.04);
  border-radius: 4px;
  min-height: 56px;
  display: flex;
  align-items: center;
}
._1m2x3e31l {
  display: flex;
  align-items: center;
  width: 100%;
}
._1m2x3e31m {
  flex-grow: 1;
  font-size: 0.75rem;
  color: var(--roctvq2);
}
._1m2x3e31n {
  flex-shrink: 0;
  margin-left: 16px;
}
@media screen and (min-width: 576px), print {
  ._1m2x3e33 {
    height: 64px;
  }
  ._1m2x3e36 {
    width: 164px;
  }
  ._1m2x3e3a {
    margin: -16px 0 0 -16px;
  }
  ._1m2x3e3b {
    padding: 16px 0 0 16px;
  }
  ._1m2x3e3j {
    width: 320px;
  }
  ._1m2x3e3l {
    padding-top: 64px;
  }
  ._1m2x3e31k {
    padding: 8px 16px;
  }
}
@media screen and (min-width: 768px), print {
  ._1m2x3e31._1m2x3e30 {
    padding-left: 230px;
  }
  ._1m2x3e31._1m2x3e30 ._1m2x3e34 {
    display: none;
  }
  ._1m2x3e3d {
    display: none;
  }
  ._1m2x3e3j {
    display: none;
  }
  ._1m2x3e314 {
    display: block;
  }
  ._1m2x3e31h {
    display: none;
  }
}
@media (hover: hover) {
  ._1m2x3e35:not(:root):hover {
    opacity: var(--roctvq1y);
  }
  ._1m2x3e3f:hover ._1m2x3e3i:before {
    opacity: 0;
  }
  ._1m2x3e3v:not(:root):hover {
    background-color: var(--roctvq1e);
  }
  ._1m2x3e3v:hover ._1m2x3e3w {
    background: linear-gradient(90deg, var(--roctvq18) 0, var(--roctvq1a) 100%);
  }
  ._1m2x3e3v:hover ._1m2x3e3x {
    background: linear-gradient(90deg, var(--roctvq18) 0, var(--roctvq1a) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  ._1m2x3e312:not(:root):hover {
    color: var(--roctvq16);
  }
  ._1m2x3e315:hover ._1m2x3e318:before {
    background: linear-gradient(90deg, var(--roctvq18) 0, var(--roctvq1a) 100%);
  }
  ._1m2x3e31f:not(:root):hover {
    color: var(--roctvq16);
  }
}
@media screen and (min-width: 992px), print {
  ._1m2x3e31m {
    font-size: 0.875rem;
  }
}